let loaderUTMTags;

function UTMTags() {
  let urlTags;
  let urlTagsObj;
  let loading = false;
  // eslint-disable-next-line
  const NEW_API_URL = apiUrl;

  function postUtm(searchUrl) {
    return fetch(`${NEW_API_URL}/cookie${searchUrl}`, {
      method: 'POST',
      credentials: 'include',
    })
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          urlTagsObj = data;
          urlTags = new URLSearchParams(data).toString();
          return urlTags;
        }
        return '';
      });
  }
  function getUtm() {
    return fetch(`${NEW_API_URL}/cookie`, {
      method: 'GET',
      credentials: 'include',
    })
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          urlTagsObj = data;
          urlTags = new URLSearchParams(data).toString();
          return urlTags;
        }
        return '';
      });
  }
  function replaceAllLink() {
    loading = false;
    const links = document.getElementsByTagName('a');

    if (!links) return;

    for (let i = 0; i < links.length; i += 1) {
      if (!(links[i].dataset.utm === 'hide')
        && links[i].href.indexOf(urlTags) === -1 && (links[i].href.indexOf('account.boxberry.ru') !== -1
        || links[i].href.indexOf('lk.boxberry.ru') !== -1)) {
        const url = new URL(links[i].href);
        const params = new URLSearchParams(url.search);

        const paramsSymbol = params.size ? '' : '?';

        // eslint-disable-next-line no-loop-func
        Object.keys(urlTagsObj).forEach((tagKey) => {
          params.append(tagKey, urlTagsObj[tagKey]);
        });
        links[i].href = `${links[i].href}${paramsSymbol}${params.toString()}`;
      }
    }
  }

  return () => {
    if (urlTags) return urlTags;
    if (loading) return 'loading';
    loading = true;
    const searchUrl = window.location.search;

    try {
      if (searchUrl) {
        postUtm(searchUrl).then(replaceAllLink);
      } else {
        getUtm().then(replaceAllLink);
      }
    } catch (e) {
      Window.console.error(e);
    }

    return urlTags;
  };
}
const urlUTMTags = UTMTags();
loaderUTMTags = true;

export { urlUTMTags as default, loaderUTMTags };
